"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const DemandSurveySamples_1 = require("./DemandSurveySamples");
const _1 = require(".");
function default_1({ insertTemplate, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-bg", css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '8px',
            padding: '10px 12px',
            borderRadius: '8px',
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '2px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 0.8)',
                } }, { children: [t('템플릿'), (0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/point_down_finger.svg`, css: { width: '20px', height: '20px' } })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: { display: 'flex' } }, { children: (0, jsx_runtime_1.jsx)(_1.ContentsTemplateTooltip, { templateName: t('주문제작'), TemplateContents: DemandSurveySamples_1.CustomOrderSample, insertTemplate: insertTemplate }) }))] })));
}
exports.default = default_1;
